var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.overlay)?_c('div',{staticClass:"inspector"},[(_vm.overlay.type == 'text_color')?_c('OverlayTextColor',{attrs:{"overlay":_vm.overlay}}):_vm._e(),_c('ObjectPrint',{attrs:{"data":_vm.overlay,"title":"overlay"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }